export { default } from './DialogTitle';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/DialogTitle/index.js
// module id = 583
// module chunks = 121